var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#E3CDFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2852_8275",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5577 17.9614H9.33268C8.41602 17.9614 7.66602 18.7114 7.66602 19.6281V23.7947C7.66602 24.2531 8.04102 24.6281 8.49935 24.6281H11.5577C12.016 24.6281 12.391 24.2531 12.391 23.7947V18.7947C12.391 18.3364 12.016 17.9614 11.5577 17.9614Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1077 14.6281H14.8827C13.966 14.6281 13.216 15.3781 13.216 16.2947V23.7947C13.216 24.2531 13.591 24.6281 14.0493 24.6281H17.941C18.3993 24.6281 18.7743 24.2531 18.7743 23.7947V16.2947C18.7743 15.3781 18.0327 14.6281 17.1077 14.6281Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.666 20.4614H20.441C19.9827 20.4614 19.6077 20.8364 19.6077 21.2947V23.7947C19.6077 24.2531 19.9827 24.6281 20.441 24.6281H23.4993C23.9577 24.6281 24.3327 24.2531 24.3327 23.7947V22.1281C24.3327 21.2114 23.5827 20.4614 22.666 20.4614Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5077 10.3364C18.766 10.0781 18.866 9.76974 18.7827 9.50308C18.6993 9.23641 18.441 9.04474 18.0743 8.98641L17.2743 8.85308C17.241 8.85308 17.166 8.79474 17.1493 8.76141L16.7077 7.87808C16.3743 7.20308 15.616 7.20308 15.2827 7.87808L14.841 8.76141C14.8327 8.79474 14.7577 8.85308 14.7243 8.85308L13.9243 8.98641C13.5577 9.04474 13.3077 9.23641 13.216 9.50308C13.1327 9.76974 13.2327 10.0781 13.491 10.3364L14.1077 10.9614C14.141 10.9864 14.166 11.0864 14.1577 11.1197L13.9827 11.8864C13.8493 12.4614 14.066 12.7197 14.2077 12.8197C14.3493 12.9197 14.6577 13.0531 15.166 12.7531L15.916 12.3114C15.9493 12.2864 16.0577 12.2864 16.091 12.3114L16.8327 12.7531C17.066 12.8947 17.2577 12.9364 17.4077 12.9364C17.5827 12.9364 17.7077 12.8697 17.7827 12.8197C17.9243 12.7197 18.141 12.4614 18.0077 11.8864L17.8327 11.1197C17.8243 11.0781 17.8493 10.9864 17.8827 10.9614L18.5077 10.3364Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2852_8275)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveState);
export default __webpack_public_path__ + "static/media/live-state.104f3fe2e1de485c11064c40dcf69677.svg";
export { ForwardRef as ReactComponent };